import { render, staticRenderFns } from "./Canceladas.vue?vue&type=template&id=c1847012&scoped=true"
import script from "./Canceladas.vue?vue&type=script&lang=js"
export * from "./Canceladas.vue?vue&type=script&lang=js"
import style0 from "./Canceladas.vue?vue&type=style&index=0&id=c1847012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1847012",
  null
  
)

export default component.exports